import * as React from 'react'
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox'
import { Button } from 'primereact/button'
import Icon from 'app/shared/components/Icon'
import { ObjectUtils } from 'primereact/utils'

type TermsMarketingCard = {
    /**
     * 상품 이용권유 동의여부
     */
    pdfUtlSlcsYn: 'Y' | 'N'
    /**
     * 상품부수 서비스 안내 동의여부
     */
    pdfNmcpSrgnCosnYn: 'Y' | 'N'
    /**
     * 전자광고 정보수신 동의여부
     */
    elcrAdvsIfrcCosnYn: 'Y' | 'N'
    /**
     * 신용카드 - 전화권유동의여부
     */
    crdTelSlcsYn: 'Y' | 'N'
    /**
     * 신용카드 - SMS권유동의여부
     */
    crdSmsSlcsYn: 'Y' | 'N'
    /**
     * 신용카드 - 서면권유동의여부
     */
    crdInwrSlcsYn: 'Y' | 'N'
    /**
     * 신용카드 - 이메일권유동의여부
     */
    crdEmlSlcsYn: 'Y' | 'N'
    /**
     * 모바일메시지서비스동의여부
     */
    mblMsgSvcCosnYn: 'Y' | 'N'
    /**
     * 부정사용방지정보제공동의여부
     */
    ilusPrvnInfoOffsYn: 'Y' | 'N'
}

export type TermListMarketingCardProps = {
    terms?: TermsMarketingCard
    /**
     * 약관 동의 상태가 변경되면 trigger. 뭐가 필요할지 몰라 다 보냄
     * @param terms 약관 동의 상태 props terms에 보낸대로 'Y', 'N'으로 채워보냄
     */
    onChange?(terms: TermsMarketingCard, isAllChecked: boolean): void
    /**
     부모 class
     */
    className?: string
}
/**
 * 체크카드 마케팅은 약관 고정이다.(추후 변경될 수 있음)
 */
type termItem = {
    /**
     * 서버에 전송하는 param값을 id로 사용, 없으면 단순 텍스트로 표시만 함.
     */
    id?: string
    /**
     * 리스트에 표시될 text
     */
    name: string
    /**
     * 있는 경우 약관 보기가 표시된다.
     */
    termId?: string
    /**
     * 하위 약관이 있는 경우
     */
    items?: termItem[]
}
const termList: termItem[] = [
    {
        name: '개인(신용)정보 선택적 동의(수집/이용)',
    },
    {
        id: 'pdfUtlSlcsYn',
        name: '카드 상품 안내 및 이용권유를 위한 수집·이용',
        termId: '111',
        items: [],
    },
    {
        id: 'pdfNmcpSrgnCosnYn',
        name: '상품/서비스 이외의 부수서비스 안내 등을 위한 수집·이용',
        termId: '222',
        items: [],
    },
    {
        id: 'elcrAdvsIfrcCosnYn',
        name: '전자적 전송매체를 통한 광고성 정보 수신 동의',
        // termId: '222',
        items: [
            { id: 'crdInwrSlcsYn', name: '서면' },
            {
                id: 'crdEmlSlcsYn',
                name: '이메일',
            },
            {
                id: 'crdTelSlcsYn',
                name: '전화',
            },

            { id: 'crdSmsSlcsYn', name: '문자' },
        ],
    },
    {
        name: '개인(신용)정보 선택적 동의(제공)',
    },
    {
        id: 'mblMsgSvcCosnYn',
        name: '모바일 메시지(카카오톡)을 통한 공지성 정보 안내신청',
        termId: '222',
        items: [],
    },
    {
        id: 'ilusPrvnInfoOffsYn',
        name: '부정사용 방지 등의 목적달성을 위해 개인(신용) 정보 제공',
        termId: '222',
        items: [],
    },
]
/**
 * 서버에서 값을 안넘기는 것을 대비해 만들어 뒀다.
 */
const defaultTerms: TermsMarketingCard = {
    pdfUtlSlcsYn: 'N',
    pdfNmcpSrgnCosnYn: 'N',
    elcrAdvsIfrcCosnYn: 'N',
    crdTelSlcsYn: 'N',
    crdSmsSlcsYn: 'N',
    crdInwrSlcsYn: 'N',
    crdEmlSlcsYn: 'N',
    mblMsgSvcCosnYn: 'N',
    ilusPrvnInfoOffsYn: 'N',
}

// const TermListMarketingCard: React.FC<TermListMarketingCardProps> = (props) => {
//     const { terms, onChange, className = 'mt-16' } = props
//     //check여부를 저장하는 terms
//     const [checkAgree, setCheckAgree] = React.useState<TermsMarketingCard>(
//         ObjectUtils.getMergedProps(terms, defaultTerms)
//     )
//     // 동의시 항목 toggle true면 펼쳐짐, false면 닫혀짐
//     const [listToggle, setListToggle] = React.useState(true)
//     // 약관 뷰어 ref
//     const termViewerRef = React.useRef<TermViewerRef>(null)

//     React.useEffect(() => {
//         setCheckAgree(ObjectUtils.getMergedProps(terms, defaultTerms))
//     }, [terms])
//     /**
//      * 체크 박스 이벤트, 루프를 줄이기 위해 종류별로 생성한다.
//      */
//     /**
//      * 하위 약관이 없는 단순 약관의 체크 박스
//      * @param e
//      */
//     const handleCheckChange = (e: CheckboxChangeEvent) => {
//         const name = e.target.name
//         const checked = e.checked
//         //단순 복재본 생성
//         const newTerms = {...checkAgree}
//         newTerms[name] = checked ? 'Y' : 'N'
//         setCheckAgree(newTerms)
//         onChange?.(newTerms, false)
//     }
//     /**
//      * 하위 약관이 있는 부모 약관의 체크 박스
//      * @param e
//      */
//     const handleCheckParentChange = (
//         e: CheckboxChangeEvent,
//         children: termItem[]
//     ) => {
//         const name = e.target.name
//         const checked = e.checked ? 'Y' : 'N'
//         //단순 복재본 생성
//         const newTerms = {...checkAgree}
//         newTerms[name] = checked
//         //부모 체크 상태에 따라 자식들을 업데이트 시킨다.
//         children.forEach((item) => {
//             newTerms[item.id] = checked
//         })
//         setCheckAgree(newTerms)
//         onChange?.(newTerms, false)
//     }
//     /**
//      * 부모 하위 약관이 있는 자식 약관의 체크 박스
//      * @param e
//      */
//     const handleCheckChildChange = (
//         e: CheckboxChangeEvent,
//         parentName: string,
//         children: termItem[]
//     ) => {
//         const name = e.target.name
//         const checked = e.checked
//         //단순 복재본 생성
//         const newTerms = {...checkAgree}
//         //우선 자신을 업데이트 시키고
//         newTerms[name] = checked ? 'Y' : 'N'
//         //자신과 형제들의 상태를 본다. 한 개라도 체크 되어 있으면 부모도 체크 상태다.
//         newTerms[parentName] = 'N'
//         const len = children.length - 1
//         for (let i = 0; i <= len; i++) {
//             const childName = children[i].id
//             if (newTerms[childName] === 'Y') {
//                 newTerms[parentName] = 'Y'
//                 break
//             }
//         }
//         setCheckAgree(newTerms)
//         onChange?.(newTerms, false)
//     }
//     /**
//      * 전체 선택 체크 박스
//      * @param e
//      */
//     const handleCheckAllChange = (e: CheckboxChangeEvent) => {
//         const checked = e.checked ? 'Y' : 'N'
//         //단순 복재본 생성
//         const newTerms = {...checkAgree}
//         for (const name in newTerms) {
//             newTerms[name] = checked
//         }
//         setCheckAgree(newTerms)
//         onChange?.(newTerms, e.checked)
//     }

//     // 전체 동의 체크 - 자식 약관 동의 여부가 전체 동의 조건인가??
//     const isAllChecked = (newTerms = checkAgree) => {
//         let checked = true
//         termList.forEach((item) => {
//             checked = checked && newTerms?.[item.id] === 'Y'
//             item.items.forEach((subItem) => {
//                 checked = checked && newTerms?.[subItem.id] === 'Y'
//             })
//         })
//         return checked
//     }

//     return (
//         <div
//             className={`checkboxs-agree ${className} ${
//                 listToggle ? '-open' : ''
//             }`.trim()}
//         >
//             <div className="group">
//                 <div className="checkbox-basic -big">
//                     <Checkbox
//                         inputId="checkbox_marketing_all"
//                         onChange={handleCheckAllChange}
//                         checked={isAllChecked()}
//                     />
//                     <label htmlFor="checkbox_marketing_all">
//                         개인(신용)정보 선택적 동의
//                     </label>
//                 </div>
//                 <Button
//                     className="btn-toggle"
//                     onClick={() => setListToggle((prev) => !prev)}
//                 >
//                     <Icon name="arrow-down" text="체크박스 항목 닫기"></Icon>
//                 </Button>
//             </div>
//             <div
//                 className="group-toggle"
//                 aria-hidden={listToggle ? false : true}
//             >
//                 <div className="list">
//                 {termList.map((item) => (
//                     <React.Fragment key={item.id}>
//                     {!item.id ? (
//                     <p className="titsub">{item.name}</p>
//                     ):(

//                         <div className="group" key={item.id}>
//                             <div className="checkbox-basic">
//                                 <Checkbox
//                                     inputId={item.id}
//                                     value={item.id}
//                                         name={item.id}
//                                         onChange={(e) => {
//                                             if (item.items.length > 0) {
//                                                 handleCheckParentChange(
//                                                     e,
//                                                     item.items
//                                                 )
//                                                 return
//                                             }
//                                             handleCheckChange(e)
//                                         }}
//                                         checked={checkAgree[item.id] === 'Y'}
//                                 />
//                                 <label htmlFor={item.id}>{item.name}</label>
//                             </div>
//                             {item.termId && (
//                                     <Button
//                                         className="btn-view"
//                                         label="보기"
//                                         title={`${item.name} 약관보기`}
//                                         onClick={() =>
//                                             termViewerRef.current.show([
//                                                 item.termId,
//                                             ])
//                                         }
//                                     />
//                                 )}
//                         </div>
//                     ))}
//                     <div className="group-subround">
//                         <div className="checkbox-basic">
//                             <Checkbox
//                                 inputId="agree5checkSubAll"
//                                 value="agree5checkSubAll"
//                                 onChange={(e) => setCheckboxSubAll(e.checked)}
//                                 checked={checkboxSubAll}
//                             />
//                             <label htmlFor="agree5checkSubAll">
//                                 상품 안내방법 전체선택
//                             </label>
//                         </div>
//                         <div className="checkitem">
//                             {checkAgreeSubItem.map((item, index) => (
//                                 <div
//                                     className="checkbox-basic -sub"
//                                     key={index}
//                                 >
//                                     <Checkbox
//                                         inputId={item.id}
//                                         value={item.id}
//                                         name="checkAgree5Sub"
//                                         onChange={checkAgreeSubChange}
//                                         checked={checkAgreeSub.includes(
//                                             item.id
//                                         )}
//                                     />
//                                     <label htmlFor={item.id}>{item.name}</label>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                     <p className="titsub">개인(신용)정보 선택적 동의(제공)</p>
//                     {checkAgree2Item.map((item) => (
//                         <div className="group" key={item.id}>
//                             <div className="checkbox-basic">
//                                 <Checkbox
//                                     inputId={item.id}
//                                     value={item.id}
//                                     name="checkAgree52"
//                                     onChange={checkAgree2Change}
//                                     checked={checkAgree2.includes(item.id)}
//                                 />
//                                 <label htmlFor={item.id}>{item.name}</label>
//                             </div>
//                         </div>
//                     ))}
//                     </React.Fragment>
//                 )}

//                 </div>
//             </div>
//             <TermViewer ref={termViewerRef} />
//         </div>
//     )
// }

// export default TermListMarketingCard

const TermListMarketingCard: React.FC<TermListMarketingCardProps> = ({
    terms: termsOri,
    className,
    onChange,
}) => {
    const [terms, setTerms] = React.useState(defaultTerms)
    const [checkboxAll, setCheckboxAll] = React.useState(false)
    const [checkboxSubAll, setCheckboxSubAll] = React.useState(false)
    const [listToggle, setListToggle] = React.useState(false)

    // check 1dep
    const checkAgreeItem = [
        {
            id: 'pdfUtlSlcsYn',
            name: '카드 상품 안내 및 이용권유를 위한 수집·이용',
        },
        {
            id: 'pdfNmcpSrgnCosnYn',
            name: '상품/서비스 이외의 부수서비스 안내 등을 위한 수집·이용',
        },
        {
            id: 'elcrAdvsIfrcCosnYn',
            name: '전자적 전송매체를 통한 광고성 정보 수신 동의',
        },
    ]
    const [checkAgree, setcheckAgree] = React.useState([])
    const checkAgreeChange = (e) => {
        const { checked, value } = e
        let _checkAgree = [...checkAgree]
        if (checked) {
            _checkAgree.push(value)
        } else {
            _checkAgree.splice(_checkAgree.indexOf(value), 1)
        }
        setcheckAgree(_checkAgree)
        const newTerms = { ...terms }
        newTerms[value] = checked ? 'Y' : 'N'
        setTerms(newTerms)
        let isAllChecked = true
        for (let name in newTerms) {
            isAllChecked = isAllChecked && newTerms[name] === 'Y'
        }
        setCheckboxAll(isAllChecked)
        onChange?.(newTerms, isAllChecked)
    }

    const checkAgree2Item = [
        {
            id: 'mblMsgSvcCosnYn',
            name: '모바일 메시지(카카오톡)을 통한 공지성 정보 안내신청',
        },
        {
            id: 'ilusPrvnInfoOffsYn',
            name: '부정사용 방지 등의 목적달성을 위해 개인(신용) 정보 제공',
        },
    ]
    const [checkAgree2, setcheckAgree2] = React.useState([])
    const checkAgree2Change = (e) => {
        const { checked, value } = e
        let _checkAgree = [...checkAgree2]
        if (checked) {
            _checkAgree.push(value)
        } else {
            _checkAgree.splice(_checkAgree.indexOf(value), 1)
        }
        setcheckAgree2(_checkAgree)
        const newTerms = { ...terms }
        newTerms[value] = checked ? 'Y' : 'N'
        setTerms(newTerms)
        let isAllChecked = true
        for (let name in newTerms) {
            isAllChecked = isAllChecked && newTerms[name] === 'Y'
        }
        setCheckboxAll(isAllChecked)
        onChange?.(newTerms, isAllChecked)
    }

    // check 2dep
    const checkAgreeSubItem = [
        {
            id: 'crdInwrSlcsYn',
            name: '서면',
        },
        { id: 'crdEmlSlcsYn', name: '이메일' },
        {
            id: 'crdTelSlcsYn',
            name: '전화',
        },
        {
            id: 'crdSmsSlcsYn',
            name: '문자',
        },
    ]
    const [checkAgreeSub, setcheckAgreeSub] = React.useState([])
    const checkAgreeSubChange = (e) => {
        const { checked, value } = e
        let _checkAgree = [...checkAgreeSub]
        if (checked) {
            _checkAgree.push(value)
        } else {
            _checkAgree.splice(_checkAgree.indexOf(value), 1)
        }
        setcheckAgreeSub(_checkAgree)
        const newTerms = { ...terms }
        newTerms[value] = checked ? 'Y' : 'N'
        setTerms(newTerms)
        let isAllChecked = true
        for (let name in newTerms) {
            isAllChecked = isAllChecked && newTerms[name] === 'Y'
        }
        setCheckboxAll(isAllChecked)
        onChange?.(newTerms, isAllChecked)
    }

    return (
        <div
            className={`checkboxs-agree ${className} ${
                listToggle ? '-open' : ''
            }`.trim()}
        >
            <div className="group">
                <div className="checkbox-basic -big">
                    <Checkbox
                        inputId="agree5checkAll"
                        value="agree5checkAll"
                        onChange={(e) => setCheckboxAll(e.checked)}
                        checked={checkboxAll}
                    />
                    <label htmlFor="agree5checkAll">
                        개인(신용)정보 선택적 동의
                    </label>
                </div>
                <Button
                    className="btn-toggle"
                    onClick={() => setListToggle((prev) => !prev)}
                >
                    <Icon name="arrow-down" text="체크박스 항목 닫기"></Icon>
                </Button>
            </div>
            <div
                className="group-toggle"
                aria-hidden={listToggle ? false : true}
            >
                <div className="list">
                    <p className="titsub">
                        개인(신용)정보 선택적 동의(수집/이용)
                    </p>
                    {checkAgreeItem.map((item) => (
                        <div className="group" key={item.id}>
                            <div className="checkbox-basic">
                                <Checkbox
                                    inputId={item.id}
                                    value={item.id}
                                    name="checkAgree5"
                                    onChange={checkAgreeChange}
                                    checked={checkAgree.includes(item.id)}
                                />
                                <label htmlFor={item.id}>{item.name}</label>
                            </div>
                        </div>
                    ))}
                    <div className="group-subround">
                        <div className="checkbox-basic">
                            <Checkbox
                                inputId="agree5checkSubAll"
                                value="agree5checkSubAll"
                                onChange={(e) => setCheckboxSubAll(e.checked)}
                                checked={checkboxSubAll}
                            />
                            <label htmlFor="agree5checkSubAll">
                                상품 안내방법 전체선택
                            </label>
                        </div>
                        <div className="checkitem">
                            {checkAgreeSubItem.map((item, index) => (
                                <div
                                    className="checkbox-basic -sub"
                                    key={index}
                                >
                                    <Checkbox
                                        inputId={item.id}
                                        value={item.id}
                                        name="checkAgree5Sub"
                                        onChange={checkAgreeSubChange}
                                        checked={checkAgreeSub.includes(
                                            item.id
                                        )}
                                    />
                                    <label htmlFor={item.id}>{item.name}</label>
                                </div>
                            ))}
                        </div>
                    </div>
                    <p className="titsub">개인(신용)정보 선택적 동의(제공)</p>
                    {checkAgree2Item.map((item) => (
                        <div className="group" key={item.id}>
                            <div className="checkbox-basic">
                                <Checkbox
                                    inputId={item.id}
                                    value={item.id}
                                    name="checkAgree52"
                                    onChange={checkAgree2Change}
                                    checked={checkAgree2.includes(item.id)}
                                />
                                <label htmlFor={item.id}>{item.name}</label>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default TermListMarketingCard
